<template>
  <div class="campaign-top">
    <!-- サークルインディケータの表示コンポーネント -->
    <Loading v-show="loading" />

    <!-- 抽選済みの場合に表示する -->
    <div v-show="lotteryResult">
      <CampaignVideo
        :videoPath="resultVideo"
        :play="lotteryVideoStart"
        :muted="true"
        :showSoundButton="false"
        :checkLoop="false"
        :showPlayOverlay="false"
        :showMuteToggleIcon="true"
        :muteIconSrc="require('@/assets/images/newyear/2026/kkrn_icon_onsei_4.png')"
        :unmuteIconSrc="require('@/assets/images/newyear/2026/kkrn_icon_onsei_1.png')"
        :hideMuteIconAfterEnd="true"
        :hideOverlayAfterEnd="true"
        :allowManualPlay="false"
        :allowReplayAfterEnd="false"
        @endVideo="handleEndResultVideo"
        @requestPlay="lotteryVideoStart = true"
      />
      <div class="campaign-text-wrap">
        <p class="speaker-note mt10">
          動画左下のスピーカーアイコンを押して音声をお楽しみください
        </p>
        <p class="mt10">
          お買い物ポイントはウォレットにお送りいたします。お楽しみにお待ちください。
        </p>
        <p class="campaign-attention-text mt12">
          使用期限：2026年2月末日まで
        </p>
        <p class="campaign-text mt12">
          ウォレットへのお買い物ポイントの付与は1月中に実施いたします。
        </p>
        <div class="explain-text-wrap mt12">
          <div class="campaign-attention-text mt12">
            <p>お買い物ポイントとは？</p>
          </div>
          <div class="mt12">
            <p>1ポイント=1円として、お買い物の際に1ポイントからご使用いただけます。<br>N selectionでのご購入にもご使用いただけます。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 未抽選の場合に表示する -->
    <div v-show="!lotteryResult">
      <!-- 未抽選の人の抽選中に表示する動画 -->
      <div v-show="loadingVideo">
        <CampaignVideo
          :videoPath="
            require('@/assets/images/newyear/2026/2026_before_omikuji.mp4')
          "
          :play="videoControl"
          :muted="true"
          :showSoundButton="false"
          :checkLoop="false"
          :showPlayOverlay="false"
          :showMuteToggleIcon="true"
          :muteIconSrc="require('@/assets/images/newyear/2026/kkrn_icon_onsei_4.png')"
          :unmuteIconSrc="require('@/assets/images/newyear/2026/kkrn_icon_onsei_1.png')"
          @endVideo="handleCheckEndVideo"
          @requestPlay="videoControl = true"
        />
        <div class="skip-button campaign-button">
          <BaseBtnDetail
            :button_text="'動画をスキップして結果を確認する'"
            :back_color="buttonSkipBackground"
            :border_radius="'10px'"
            :border="false"
            :font_weight="'bold'"
            :disabled="!checkSkip"
            @handleClick="handleSkip"
            @endVideo="handleCheckEndVideo"
          />
        </div>
      </div>

      <!-- おみくじ画面表示用 -->
      <div v-show="!loadingVideo">
        <CampaignOmikujiHeader />
        <div class="campaign-button">
          <BaseBtnDetail
            :button_text="'おみくじをひく'"
            :back_color="buttonBackColor"
            :border_radius="'10px'"
            :border="false"
            :disabled="!available"
            :font_weight="'bold'"
            @handleClick="handleLottely"
          />
        </div>
        <div class="campaign-text-wrap">
          <p class="campaign-text">
            上のボタンを押しておみくじを引いてください。<br />おみくじの結果によってお買い物ポイントをもれなくプレゼントいたします！
          </p>
          <p class="campaign-text">大吉:10,000円分のお買い物ポイント</p>
          <p class="campaign-text">中吉:1,000円分のお買い物ポイント</p>
          <p class="campaign-text">小吉:100円分のお買い物ポイント</p>
        </div>
        <div class="campaign-text-wrap">
          <p class="campaign-text">
            【おみくじ実施期間】2026年1月15日(木)まで
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/common/Loading";
import BaseBtnDetail from "@/components/common/BaseBtnDetail";
import CampaignVideo from "@/components/campaign/CampaignVideo";
import CampaignOmikujiHeader from "@/components/campaign/CampaignOmikujiHeader";
import CampaignOmikuji from "@/components/api/campaign/omikujiCampaign";

export default {
  components: { Loading, BaseBtnDetail, CampaignVideo, CampaignOmikujiHeader },
  data() {
    return {
      loading: false, // 初回描画時のloadingフラグ
      available: false, // 期限切れのフラグ
      loadingVideo: false, // 抽選結果が出るまでのloading用の動画フラグ
      lotteryResult: false, // 抽選結果表示するフラグ
      checkSkip: false, //skipボタン使用可能かの確認フラグ
      apiStatus: false, //API取得できたかどうか判定するフラグ
      videoControl: false, //videoの再生を判定するフラグ
      lotteryVideoStart: false,
      resultVideo: "", //おみくじの結果動画のURL
      message: "", // errorメッセージ
      userId: 0
    };
  },

  // 値によってボタンの色を変更する
  computed: {
    buttonBackColor() {
      return this.available ? "#007bff" : "#595959";
    },
    buttonSkipBackground() {
      return this.checkSkip ? "#007bff" : "#595959";
    }
  },

  methods: {
    // スキップボタン押した時に走る処理
    handleSkip() {
      this.lotteryResult = true;
      this.$nextTick(() => {
        this.lotteryVideoStart = true;
      });
    },

    // 動画が終わった時に走る処理
    handleCheckEndVideo() {
      this.videoControl = false;
      if (this.apiStatus) {
        this.lotteryResult = true;
        // 結果動画は自動再生（ミュート）で開始
        this.$nextTick(() => {
          this.lotteryVideoStart = true;
        });
      }
    },
    handleEndResultVideo() {
      // ループ防止のため、終了時に再生フラグを下げておく
      this.lotteryVideoStart = false;
    },

    // おみくじ引くボタン押した時の処理
    async handleLottely() {
      // 中間の事前動画ページは表示せず、直接結果取得→結果表示へ遷移する
      this.loading = true;
      this.loadingVideo = false;
      this.videoControl = false;
      try {
        let res = await CampaignOmikuji.getCampaignOmikujiResult(this.userId);
        if (res.status == "OK") {
          this.resultVideo = res.resultFileUrl ? res.resultFileUrl : "";
          this.apiStatus = true;
          this.checkSkip = false;
          // 結果画面を即時表示し、結果動画を自動再生（ミュート）で開始
          this.lotteryResult = true;
          this.$nextTick(() => {
            this.lotteryVideoStart = true;
          });
        } else {
          this.message = res.message;
          this.$router.push({
            name: "CampaignOmikujiError",
            params: { errorMessage: this.message, userId: this.userId }
          });
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "CampaignOmikujiError",
          params: {
            errorMessage: "エラーが発生しました。初めからやり直してください。",
            userId: this.userId
          }
        });
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    this.loading = true;
    this.userId = this.$route.params.id;
    // this.userId = 4;
    try {
      let res = await CampaignOmikuji.getCampaignOmikuji(this.userId);
      if (res.entered) {
        this.lotteryResult = res.entered;
        this.resultVideo = res.result ? res.result.resultFileUrl : "";
        this.$nextTick(() => {
          this.lotteryVideoStart = true;
        });
      }
      console.log(res);
      this.available = res.available;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="css" scoped>
.campaign-top {
  background-color: white;
  height: 100vh;
}
.campaign-button {
  padding: 30px 40px 10px 40px;
}
.campaign-text-wrap {
  padding: 10px 20px 10px 20px;
}
.campaign-text {
  padding: 5px;
}
.campaign-attention-text {
  padding: 10px, 0 10px 0;
  font-weight: 900;
}

.explain-text-wrap {
  padding: 10px 20px 10px 20px;
  background-color: #DFE9F6;
}
.speaker-note {
  color: #000;
  font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// src/views/campaign/CampaignOmikuji.vue